import { type DBSchema, type IDBPDatabase, openDB } from "idb";

export const FIELD_LEAD_DB_NAME = "crm-pwa-field-leads";
const FIELD_LEAD_DB_VERSION = 1;
const STORE = "loads";

type FieldLeadDelivery = "sent" | "queued";

export type FieldLeadContactSource = "agenda" | "manual";

export interface FieldLeadRecord {
  clientLoadId: string;
  ownerKey: string;
  contactName: string;
  machineLabel: string;
  loadedAt: string;
  delivery: FieldLeadDelivery;
  leadId: string | null;
  contactSource?: FieldLeadContactSource;
}

interface FieldLeadDbSchema extends DBSchema {
  loads: {
    key: string;
    value: FieldLeadRecord;
  };
}

export type FieldLeadDatabase = IDBPDatabase<FieldLeadDbSchema>;

export function openFieldLeadDb(): Promise<FieldLeadDatabase> {
  return openDB<FieldLeadDbSchema>(FIELD_LEAD_DB_NAME, FIELD_LEAD_DB_VERSION, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(STORE)) {
        db.createObjectStore(STORE, { keyPath: "clientLoadId" });
      }
    },
  });
}

export function readAllRecords(db: FieldLeadDatabase): Promise<FieldLeadRecord[]> {
  return db.getAll(STORE);
}

export async function readRecord(
  db: FieldLeadDatabase,
  clientLoadId: string,
): Promise<FieldLeadRecord | null> {
  return (await db.get(STORE, clientLoadId)) ?? null;
}

export async function writeRecord(db: FieldLeadDatabase, record: FieldLeadRecord): Promise<void> {
  await db.put(STORE, record);
}

export async function removeRecord(db: FieldLeadDatabase, clientLoadId: string): Promise<void> {
  await db.delete(STORE, clientLoadId);
}
